import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { fetchThoughtSpotToken } from '../api'
import { reportsKeys } from '../queryKeys/reportsKeys'

const useGetThoughtSpotTokenQuery = (userId: string | undefined) => {
  return useQuery(
    reportsKeys.thoughtSpotToken(userId ?? ''),
    () => fetchThoughtSpotToken(userId!),
    {
      enabled: !!userId,
      staleTime: 10 * 60 * 1000,
      onError: () => {
        errorToast('Failed to load visualization. Please try again.')
      },
    }
  )
}

export default useGetThoughtSpotTokenQuery
